module.exports = __webpack_public_path__ + "img/map-active.f2d7cfea.png";